import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import PricingPanel from "../PricingPanel/PricingPanel";
import { PricingSectionCss } from "./PricingSectionCss";
import { PricingSection as PricingSectionI } from "../../types/interfaces/PricingSection";
import { LoaderFullscreen } from "modules/core/components";

const PricingSection = (data: PricingSectionI) => {
  const [loading, setLoading] = useState(false);

  if (loading) return <LoaderFullscreen/>

  return (
    <div className="pricing-panel" style={PricingSectionCss.main}>
      <Container style={{ maxWidth: "1200px" }}>
        {data?.title && (
          <h2 className="text-center" style={PricingSectionCss.heading}>
            {data?.title}
          </h2>
        )}
        <Row className="row-cols-md-3 row-cols-1">
          {data?.panels.map((panel, index) => (
            <PricingPanel
              key={index}
              position={index}
              price={panel?.priceFormatted}
              duration={panel?.name}
              category={panel?.productCategory}
              type={panel?.productType}
              description={panel?.description}
              uuid={panel?.uuid}
              loading={loading} 
              setLoading={setLoading}
            />
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default PricingSection;
